import {
  Box,
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Card from "components/card/Card";
import AdjustTab from "views/admin/tracking/components/Adjust";
import SingularTab from "views/admin/tracking/components/Singular";
import AppsFlyerTab from "views/admin/tracking/components/AppsFlyer";

const TAB_HEADERS = [
  { name: "Adjust", disabled: false, component: AdjustTab },
  { name: "Singular", disabled: false, component: SingularTab },
  { name: "AppsFlyer", disabled: false, component: AppsFlyerTab },
];

export default function Tracking() {
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const provider = queryParams.get("provider");

  const tabIndex = useMemo(() => {
    const foundIndex = TAB_HEADERS.findIndex(
      (header) => header.name.toLowerCase() === provider
    );
    return foundIndex === -1 ? 0 : foundIndex;
  }, [provider]);

  const handleTabHeaderClick = (index: number) => {
    const newSearchParams = new URLSearchParams({
      provider: TAB_HEADERS[index].name.toLowerCase(),
    });

    //window.location.search = newSearchParams.toString();
    history.push({ search: newSearchParams.toString() });
  };

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }} borderRadius={8}>
      <Flex p={8} backgroundColor="white" borderRadius={8}>
        <Tabs
          flex={1}
          variant="enclosed"
          defaultIndex={tabIndex}
          backgroundColor="white"
          isFitted
          isLazy
        >
          <TabList px="25px">
            {TAB_HEADERS.map((header, idx) => (
              <Tab
                _active={{ color: "white", backgroundColor: "brand.500" }}
                _selected={{ color: "white", backgroundColor: "brand.500" }}
                key={header.name}
                isDisabled={header.disabled}
                _disabled={{ cursor: "not-allowed" }}
                onClick={() => handleTabHeaderClick(idx)}
              >
                {header.name}
              </Tab>
            ))}
          </TabList>
          <TabPanels>
            {TAB_HEADERS.map((header) => (
              <TabPanel key={header.name}>
                <header.component />
              </TabPanel>
            ))}
          </TabPanels>
        </Tabs>
      </Flex>
    </Box>
  );
}
